import { useUnit } from 'effector-react';
import { useSearchParams } from 'react-router';
import { Stack } from '@mantine/core';
import { useSearchParamsSync } from '~/shared/lib/hooks/useSearchParamsSync';
import { TradersList } from './TradersList';
import { $tradersFilter, TradersFilter } from './TradersFilter';
import { setTradersFilter } from './TradersFilter/model';
import { getPayinTradersSearchParams } from './lib/searchParams';
import { openTrader, paginationModel } from './model';

export const Traders = () => {
    const filters = useUnit($tradersFilter);
    const [searchParams] = useSearchParams();
    const { traderName } = getPayinTradersSearchParams(searchParams);

    useSearchParamsSync((value) => {
        setTradersFilter({
            traderName: { value },
            statuses: undefined,
        });
        paginationModel.setPage(0);
    }, traderName);

    return (
        <Stack gap='sm'>
            <TradersFilter />
            <TradersList
                filter={filters}
                paginationModel={paginationModel}
                onClick={(t) => t.id?.value && openTrader(t.id?.value)}
            />
        </Stack>
    );
};
